import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { LogEntry, TimeLogSummary } from 'globals/store/tasks.data';
import { JustTimeToHHMM } from 'src/app/services/pipes/justTimeToHHMM.pipe';
@Component({
    selector: 'time-log-summary',
    template: `

<ng-template #property let-name="name" let-time="time" let-diff="diff">
  <div class="property-holder">
    <div class="property">{{ name }}:</div>
    <div class="time" [ngClass]="{negative: time.negative, isGray: !!time.is0, isGreen: !time.is0 && showGreen && diff && !time.negative}">{{  time | justTimeToHHMM }}</div>
  </div>
</ng-template>

<div class="log-header" *ngIf="!!timeLogSummary">
  <div *ngIf="showLogButton" class="toggle-menu" [matMenuTriggerFor]="toggleMenu">
    <icon matIcon="more_vert"></icon>
  </div>
  <mat-menu #toggleMenu="matMenu" class="condensed" xPosition="before">
    <button mat-menu-item (click)="onExport.emit()">Export</button>
  </mat-menu>
  <button  id="logButton" mat-button color="primary" class="desktop" (click)="newLog.emit()" *ngIf="showLogButton">LOG TIME</button>
  <ng-container *ngIf="!!timeLogSummary?.difference" [ngTemplateOutlet]="property" [ngTemplateOutletContext]="{name: 'Difference', time: timeLogSummary.difference, diff: true}"></ng-container>
  <ng-container *ngIf="!!timeLogSummary?.loggedTime" [ngTemplateOutlet]="property" [ngTemplateOutletContext]="{name: 'Logged time', time: timeLogSummary.loggedTime}"></ng-container>
  <ng-container *ngIf="!!timeLogSummary?.estimatedTime" [ngTemplateOutlet]="property" [ngTemplateOutletContext]="{name: 'Est. time', time: timeLogSummary.estimatedTime}"></ng-container>
</div>
`,
    styleUrls: ['./time-log.scss'],
    styles: [`
  .toggle-menu icon { color:rgba(0,0,0,0.4); cursor: pointer; position: absolute; top: 3px; right: -5px;}

`],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatMenuModule, IconComponent, JustTimeToHHMM],
})

export class TimeLogSummaryComponent {

  @Input() timeLogSummary: TimeLogSummary
  @Input() showLogButton = false
  @Input() showGreen = true
  @Input() showMenu = false

  @Output() onExport: EventEmitter<null> = new EventEmitter()
  @Output() newLog: EventEmitter<LogEntry> = new EventEmitter()

}